/**
 * Coerces string "true"/"false" values in a filters object to actual booleans.
 * URL query params are always strings; this ensures bool? backend fields deserialize correctly.
 */
export const coerceFilterBooleans = (filters: any): any => {
  if (!filters || typeof filters !== 'object') return filters;
  const result: any = {};
  for (const key of Object.keys(filters)) {
    const value = filters[key];
    if (value === 'true') result[key] = true;
    else if (value === 'false') result[key] = false;
    else result[key] = value;
  }
  return result;
};
